import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './login.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faEnvelope,
  faLock,
  faArrowRight,
  faShieldHalved,
  faComments,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons';

const API_BASE = 'https://welaunchyou.com.br/crm-wly';

function Login({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const numberFlag = (value, fallback = 0) => {
    if (value === undefined || value === null || value === '') {
      return fallback;
    }

    if (value === true || value === 'true') {
      return 1;
    }

    if (value === false || value === 'false') {
      return 0;
    }

    return Number(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE}/login.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          email,
          senha: password,
        }),
        credentials: 'include',
      });

      let data = null;
      const contentType = response.headers.get('content-type') || '';

      if (contentType.includes('application/json')) {
        data = await response.json();
      } else {
        data = {
          ok: false,
          error: 'Falha na autenticação.',
        };
      }

      if (response.ok && data?.ok === true) {
        const usuarioObject = {
          id: Number(data.id),

          usuario_acesso_id: data.usuario_acesso_id ?? null,
          subusuario: numberFlag(data.subusuario, 0),

          nome: data.nome,
          nome_conta: data.nome_conta ?? data.nome,
          email: data.email ?? email,

          tipo_usuario: data.tipo_usuario,
          whatsapp_ativo: numberFlag(data.whatsapp_ativo, 0),
          ia_ativa: numberFlag(data.ia_ativa, 0),

          menu_dashboard: numberFlag(data.menu_dashboard, 1),
          menu_leads: numberFlag(data.menu_leads, 1),
          menu_acoes: numberFlag(data.menu_acoes, 1),
          menu_tags: numberFlag(data.menu_tags, 1),
          menu_whatsapp: numberFlag(data.menu_whatsapp, 1),
          menu_openai: numberFlag(data.menu_openai, 0),
          menu_meta_ads: numberFlag(data.menu_meta_ads, 0),
          menu_google_ads: numberFlag(data.menu_google_ads, 0),
          menu_dados: numberFlag(data.menu_dados, 0),
          menu_configuracoes: numberFlag(data.menu_configuracoes, 1),
          menu_ajuda: numberFlag(data.menu_ajuda, 1),
        };

        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('isAdmin', String(!!data.isAdmin));
        localStorage.setItem('usuario', JSON.stringify(usuarioObject));

        setIsAuthenticated(true);
        navigate('/dashboard', { replace: true });
        return;
      }

      setError(data?.error || 'Erro ao autenticar. Verifique suas credenciais.');
    } catch (err) {
      setError('Erro ao se conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-shell">
        <aside className="login-brand-panel">
          <div className="login-brand-glow"></div>

          <img
            src="https://welaunchyou.com.br/crm-wly/uploads/logos/logo-norea-n-branco2.png"
            alt="Logo Nórea"
            className="login-brand-logo"
          />

          <div className="login-brand-content">
            <span className="login-eyebrow">Nórea CRM</span>

            <h1>
              Organize leads, conversas e vendas em um só lugar.
            </h1>

            <p>
              Acesse sua central de relacionamento, acompanhe oportunidades e
              mantenha seu atendimento conectado ao WhatsApp.
            </p>
          </div>

          <div className="login-feature-list">
            <div className="login-feature-item">
              <span>
                <FontAwesomeIcon icon={faComments} />
              </span>
              <div>
                <strong>WhatsApp integrado</strong>
                <small>Atendimento centralizado no CRM.</small>
              </div>
            </div>

            <div className="login-feature-item">
              <span>
                <FontAwesomeIcon icon={faChartLine} />
              </span>
              <div>
                <strong>Funil de vendas</strong>
                <small>Acompanhe leads e oportunidades.</small>
              </div>
            </div>

            <div className="login-feature-item">
              <span>
                <FontAwesomeIcon icon={faShieldHalved} />
              </span>
              <div>
                <strong>Acesso seguro</strong>
                <small>Permissões por usuário e subusuário.</small>
              </div>
            </div>
          </div>
        </aside>

        <section className="login-card-panel">
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-header">
              <img
                src="https://welaunchyou.com.br/crm-wly/uploads/logos/logo-norea-n-branco2.png"
                alt="Logo Nórea"
                className="login-logo"
              />

              <div>
                <h2>Entrar no CRM</h2>
                <p>Acesse sua conta para continuar.</p>
              </div>
            </div>

            {error && (
              <div className="login-error" role="alert">
                {error}
              </div>
            )}

            <div className="login-field">
              <label htmlFor="email">E-mail</label>

              <div className="login-input-wrap">
                <FontAwesomeIcon icon={faEnvelope} className="login-input-icon" />

                <input
                  type="email"
                  id="email"
                  placeholder="seuemail@empresa.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="password">Senha</label>

              <div className="login-input-wrap">
                <FontAwesomeIcon icon={faLock} className="login-input-icon" />

                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="login-eye-button"
                  onClick={() => setShowPassword((value) => !value)}
                  aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                  title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>

            <button type="submit" className="login-submit-btn" disabled={loading}>
              <span>{loading ? 'Entrando...' : 'Entrar'}</span>

              {!loading && (
                <FontAwesomeIcon icon={faArrowRight} />
              )}
            </button>

            <p className="forgot-password">
              <Link to="/recuperar-senha">Esqueci minha senha</Link>
            </p>
          </form>
        </section>
      </section>
    </main>
  );
}

export default Login;